import * as React from 'react';

export function AlertTriangle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8646 13.9528C10.8646 14.4366 10.4724 14.8289 9.98852 14.8289C9.50466 14.8289 9.11242 14.4366 9.11242 13.9528C9.11242 13.4689 9.50466 13.0767 9.98852 13.0767C10.4724 13.0767 10.8646 13.4689 10.8646 13.9528Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.778 8.67137L10.778 11.606C10.778 12.042 10.4246 12.3955 9.98853 12.3955C9.5525 12.3955 9.19903 12.042 9.19903 11.606L9.19903 8.67137C9.19903 8.23534 9.5525 7.88186 9.98853 7.88186C10.4246 7.88186 10.778 8.23534 10.778 8.67137Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.98847 2L1 17.7508H18.9769L9.98847 2ZM9.98847 5.18581L3.71912 16.1718H16.2578L9.98847 5.18581Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default AlertTriangle;
